import { Directive, ElementRef, Input, HostListener } from '@angular/core';

import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';

@Directive({
  selector: '[appTrialRequestEnterCell]',
})
export class CustomPopup1Directive {
  @Input() pop1: NgbPopover;
  @Input() pop2: NgbPopover;
  @Input() pop3: NgbPopover;

  constructor(private readonly elementRef: ElementRef) {}

  @HostListener('mouseenter')
  public onMouseOver() {
    if (this.pop2.isOpen()) {
      this.pop2.close();
    }
    if (this.pop3.isOpen()) {
      this.pop3.close();
    }
    this.pop1.open();
  }
}
